/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

require('./bootstrap');

var Bugsnag = require('@bugsnag/js')
Bugsnag.start({
    apiKey: BUGSNAG_API_KEY,
    appVersion: BUGSNAG_APP_VERSION,
    releaseStage: BUGSNAG_RELEASE_STAGE,
    onError: function (event) {
        event.setUser(window.BUGSNAG_INFO.user.id, window.BUGSNAG_INFO.user.email, window.BUGSNAG_INFO.user.name)
    }
})

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

require('./components/AdminArea');
require('./components/CoupleArea');
require('./components/CoupleApprovalArea/index');
